export
const name: string = "Final";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform  highp sampler2D u_tex_acc_color;
    uniform  highp sampler2D u_tex_acc_depth;
`;

export
const varyings: string = `
    varying  vec2      v_tex_coord;
`;

export
const implementation: string = `
    // https://www.gamedev.net/forums/topic/642119-oit-with-weighted-average/
    // http://jcgt.org/published/0002/02/09/
    // but from the first reference I use different blending for the output with the background
    void main(void)
    {
        float n = texture2D(u_tex_acc_depth, v_tex_coord).r * 255.0;
        highp vec4 color_sum = texture2D(u_tex_acc_color, v_tex_coord);

        if (n > 0.0001 && (color_sum.a * n) > 0.0001) {
            // weighted average color, average alpha,
            highp vec4 avgColor = vec4(color_sum.rgb * n / (color_sum.a * n), (color_sum.a * n) / n);
            // the alpha, used to blend with the background is computed by assuming that all transparent layers have the average alpha:
            highp float dstAlpha = 1.0 - pow(max(0.0, 1.0 - avgColor.w), n);
            // write out the average color and the alpha, used for compositing
            gl_FragColor = vec4(avgColor.xyz, dstAlpha);
        }
        else {
            discard; // this is not performance problem here as we draw the fullscreen quad with depth test off
        }
    }
`;
